import { render, staticRenderFns } from "./MedicationDisplay.vue?vue&type=template&id=3cc55d8b&scoped=true&"
import script from "./MedicationDisplay.vue?vue&type=script&lang=ts&"
export * from "./MedicationDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./MedicationDisplay.vue?vue&type=style&index=0&id=3cc55d8b&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc55d8b",
  null
  
)

export default component.exports